import type { FinaliteConsentement } from './modele.js';

/**
 * Libellés de la fiche héritier : une donnée versionnée, jamais de texte dispersé dans les composants.
 * Le libellé « Canal préféré » est conservé tel quel (réunion du 16/10, point 62).
 */
export const VERSION_LIBELLES = '2026-10-17';

export const CANAUX: Readonly<Record<string, string>> = {
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  telephone: 'Téléphone',
  courrier: 'Courrier',
  portail: 'Portail',
};
export const CANAL_INCONNU = 'Non renseigné';

export const STATUTS_PIECE: Readonly<Record<string, string>> = {
  attendu: 'manquante',
  demande: 'demandée, non reçue',
  recu: 'reçue, à vérifier',
  verifie: 'vérifiée',
  refuse: 'refusée',
};

export const ETATS_CONSENTEMENT: Readonly<Record<string, string>> = {
  accorde: 'accepté',
  refuse: 'refusé',
  non_recueilli: 'non recueilli',
};

/** Consentements détaillés affichés : numéro et adresse sont deux cases séparées. */
export interface LigneConsentement {
  finalite: FinaliteConsentement;
  libelle: string;
  court: string | null;
}
export const LIGNES_CONSENTEMENT: readonly LigneConsentement[] = [
  { finalite: 'contact_cabinet', libelle: 'Être contacté(e) par le cabinet', court: null },
  { finalite: 'partage_numero_famille', libelle: 'Numéro de téléphone communiqué à la famille', court: 'Numéro' },
  { finalite: 'partage_adresse_famille', libelle: 'Adresse communiquée à la famille', court: 'Adresse' },
];

export const TYPES_COORDONNEE: Readonly<Record<string, string>> = {
  phone: 'Téléphone',
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  address: 'Adresse',
};

/** Motif de la pause « on laisse respirer » (un motif d'au moins 3 caractères est exigé par le contrat). */
export const MOTIF_PAUSE = 'On laisse respirer';

/** Ordre des canaux proposés pour le recueil d'un consentement : aucun n'est présélectionné. */
export const CANAUX_RECUEIL: readonly string[] = ['telephone', 'whatsapp', 'email', 'courrier', 'portail'];

/** Partage hors équipe indisponible : la raison est dite à l'écran, jamais une liste vide muette. */
export const PARTAGE_INDISPONIBLE_DROIT =
  'Le partage hors de l’équipe est indisponible pour votre rôle : il est réservé à la direction et à l’assistante du Cabinet MAAT. Demandez-leur de réaliser ce partage.';
export const PARTAGE_INDISPONIBLE_PANNE =
  'Le partage hors de l’équipe est indisponible pour le moment : la liste des destinataires n’a pas pu être lue. Réessayez dans un instant ; si cela persiste, contactez le Cabinet MAAT.';

/** Échanges illisibles (messagerie indisponible ou en panne) : la fiche reste utilisable et le dit, jamais « aucun échange ». */
export const ECHANGES_INDISPONIBLES =
  'Les échanges avec cette personne ne peuvent pas être affichés pour le moment. Le reste de la fiche est à jour.';
